
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-tools",
      function () {
        return require("private-next-pages/ai-tools/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-tools"])
      });
    }
  